<app-header></app-header>
<main class="p-4 main-content">
  <router-outlet></router-outlet>
</main>
<app-ai-help-button></app-ai-help-button>
